import { Box, Typography, Button } from "@mui/material";

export default function Maintenance() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#FAFAFA",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 3
      }}
    >
      <style>{`
        .maintenance-image {
          width: 200px;
          height: 200px;
          margin-bottom: 20px;
        }
        .maintenance-image img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      `}</style>
      
      {/* Espacio para una imagen */}
        <div className="maintenance-image">
            <img src="/images/mantenimiento.png" alt="Búsqueda" />
        </div>

      <Typography
        variant="h4"
        sx={{ color: "#00796B", fontWeight: "bold", mb: 2 }}
      >
        Página en mantenimiento
      </Typography>

      <Typography sx={{ color: "#555", maxWidth: 400, mb: 3 }}>
        Estamos trabajando para mejorar tu experiencia.  
        Vuelve a intentarlo más tarde.
      </Typography>

      <Button
        variant="contained"
        sx={{ backgroundColor: "#00796B", "&:hover": { backgroundColor: "#004D40" } }}
        onClick={() => (window.location.href = "/")}
      >
        Volver al inicio
      </Button>
    </Box>
  );
}
